import { CellText } from "components/Omnisearch/helpComponents/CellText";
import { DateTime } from "luxon";

export function DueDateCell({
  dueDate,
  deadline
}: {
  dueDate?: string;
  deadline?: string;
}) {
  // Use submission.dueDate if available (for materialized submissions),
  // otherwise fall back to deadline (for virtual events)
  const normalizedDueDate = dueDate ?? deadline ?? "";
  return (
    <CellText variant="body2">
      {DateTime.fromISO(normalizedDueDate).toFormat("MM/dd/yyyy")}
    </CellText>
  );
}
